import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75acdf5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-text" }
const _hoisted_2 = { class: "loading-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 正在加载... ", -1))


const __default__ = {
  name: 'FooterText'
};

import loadingGif from '@/assets/img/loading.gif';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isLoading: { type: Boolean },
    listLength: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("span", null, " - 学无止境，思也无涯 - ", 512), [
      [_vShow, !__props.isLoading && __props.listLength > 10]
    ]),
    _withDirectives(_createElementVNode("span", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(loadingGif),
        alt: "",
        class: "loading-gif"
      }, null, 8, _hoisted_3),
      _hoisted_4
    ], 512), [
      [_vShow, __props.isLoading]
    ])
  ]))
}
}

})